module.exports = __webpack_public_path__ + "img/guide_06.1d673e7b.svg";